<template v-slot:item.status="{ item }">
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-chip v-bind="attrs" v-on="on" small :color="getColor(item.status)">
      </v-chip>
    </template>
    <span> {{ fillToolTips(item.status) }} </span>
  </v-tooltip>
</template>
<script>
import { projectStatus } from "@/utility/constants";
// import TooltipsData from "@/services/lableTooltips.js";
export default {
  name: "projectStatusChip",
  props: ["item"],
  data() {
    return {};
  },
  methods: {
    fillToolTips(status) {
      const defaultStatus = "Inputs Required";
      let text;
      switch (status) {
        case projectStatus.INPUTS_REQUIRED: text = defaultStatus; break;
        case projectStatus.ANALYSIS_READY_BAU: text = defaultStatus; break;
        case projectStatus.ANALYSIS_READY_DER: text = "Analysis In Progress"; break;
        case projectStatus.ANALYSIS_COMPLETED: text = "Analysis Completed"; break;
        case projectStatus.ANALYSIS_FAILED: text = "Analysis Failed"; break;
        default: text = defaultStatus; break;
      }
      return text;
    },

    getColor(status) {
      let color;
      switch (status) {
        case projectStatus.INPUTS_REQUIRED: color = "primary"; break;
        case projectStatus.ANALYSIS_READY_BAU: color = "primary"; break;
        case projectStatus.ANALYSIS_READY_DER: color = "#FFC107"; break;
        case projectStatus.ANALYSIS_COMPLETED: color = "green"; break;
        case projectStatus.ANALYSIS_FAILED: color = "red"; break;
        default: color = "primary"; break;
      }
      return color;
    },
  },
};
</script>